import { IEntity } from "../interfaces/entity";

export class StripeInfoDto implements IEntity {
  id: number

  userId: string

  stripeSubscriptionId: string
  stripeCustomerId: string
  stripeAccountId: string
  stripeOnboardingUrl: string
  stripeDashboardUrl: string
  stripeProductId: string

  stripePaymentMethodId: string
  stripeInvoiceId: string

  entityName = "StripeInfoDto";

  getPrimaryKey() {
    return this.id;
  }

  updateValues(formValue: Partial<StripeInfoDto>) {
    Object.assign(this, formValue);
  }

}
